import { render, staticRenderFns } from "./VipForIos.vue?vue&type=template&id=594191de&scoped=true"
import script from "./VipForIos.vue?vue&type=script&lang=js"
export * from "./VipForIos.vue?vue&type=script&lang=js"
import style0 from "./VipForIos.vue?vue&type=style&index=0&id=594191de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "594191de",
  null
  
)

export default component.exports